import React, { type FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'
import { CardItem } from '../CardItem/CardItem'

import classes from './CardList.module.scss'
import { CardSkeleton } from '../CardSkeleton/CardSkeleton'

type CardListProps = {
  items: FeedData[]
  isLoading?: boolean
}

export const CardList: FC<CardListProps> = ({ items, isLoading = true }) => {
  const skeletonsList = Array.from({ length: 4 }).map((_, index) => (
    <CardSkeleton key={index} />
  ))

  const itemsCount = items.length
  const itemsList = items.map((item) => <CardItem key={item.id} item={item} />)

  if (itemsCount === 0 && !isLoading) {
    return <div className={classes.EmptyList}>No items found</div>
  }

  return (
    <div className={classes.Container}>
      {isLoading ? skeletonsList : itemsList}
    </div>
  )
}
